<template>
  <div class="container internal-section text-justify">
    <h1 class="text-h4 text-center q-py-lg">{{ $t('terms.title') }}</h1>

    <q-card class="rounded-borders">
      <q-card-section>
        <p>{{ $t('terms.p1') }}</p>
        <p>{{ $t('terms.p2') }}</p>

        <div class="text-h5 q-mt-lg">{{ $t('terms.section1.title') }}</div>
        <p>{{ $t('terms.section1.p1') }}</p>
        <q-list bordered class="rounded-borders">
          <q-item v-for="i in 5" :key="i">
            <q-item-section>{{ $t(`terms.section1.list.${i - 1}`) }}</q-item-section>
          </q-item>
        </q-list>
        <p>{{ $t('terms.section1.p2') }}</p>
        <p>{{ $t('terms.section1.p3') }}</p>
      </q-card-section>

      <q-separator />
      <q-card-actions align="right">
        <span class="text-caption text-grey">{{ $t('terms.footer') }}</span>
      </q-card-actions>
    </q-card>
  </div>
</template>
<script setup lang="ts">
import { useSeoMeta } from 'src/composables/useSeoMeta'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

useSeoMeta({
  title: () => t('terms.title'),
  description: () => t('terms.p1'),
  type: 'website',
  schema: () => ({ type: 'WebPage' }),
})
</script>
